import * as request from './utils/requester';

export const getAll = (page) => request.get(`/certificate?page=${page}`);

export const getById = (id) => request.get(`/certificate/${id}`);

export const create = (data) => request.post('/certificate', data);

export const edit = (data) => request.put(`/certificate/${data._id}`, data);

export const del = (data) => request.del(`/certificate/${data._id}`);


export const getOption = (option) => request.get(`/certificate?option=${option}`);